<template>
  <div :style="{ position: 'relative' }">
    <InputText
      :modelValue="displayValue" 
      :disabled="disabled"
      readonly
      @click="toggle"
      class="w-full"
      style="cursor: 'pointer';"
    /> 
    
    <!-- Dropdown Panel -->
    <OverlayPanel ref="overlayPanel" :showCloseIcon="false" class="w-80" style="marginTop: -1px;">
      <div class="p-1">
        <div class="font-bold mb-3">Set Default Date</div>
        
        <!-- Radio Button Options -->
        <div class="flex flex-column gap-3">
          <div class="flex align-items-center">
            <RadioButton 
              v-model="selectedOption" 
              inputId="autoUpdate" 
              name="defaultDateType" 
              value="none"
              @change="onRadioChange"
            />
            <label for="autoUpdate" class="ml-2">Auto Update</label>
          </div>
          
          <div class="flex align-items-center">
            <RadioButton 
              v-model="selectedOption" 
              inputId="CurrentDate" 
              name="defaultDateType" 
              value="current"
              @change="onRadioChange"
            />
            <label for="CurrentDate" class="ml-2">Default to current date</label>
          </div>
          
          <div class="flex align-items-center">
            <RadioButton 
              v-model="selectedOption" 
              inputId="specificDate" 
              name="defaultDateType" 
              value="specific" 
            />
            <label for="specificDate" class="ml-2">Choose a specific default date</label>
          </div>
          
          <!-- Calendar appears when specific date is selected -->
          <Calendar 
            v-if="selectedOption === 'specific'"
            v-model="specificDate"
            dateFormat="dd/mm/yy"
            placeholder="Select default date"
            class="w-full"
            @date-select="onDateSelect"
          />
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext'
import OverlayPanel from 'primevue/overlaypanel'
import RadioButton from 'primevue/radiobutton'
import Calendar from 'primevue/calendar'

import { format } from 'date-fns';

export default {
  name: 'DateTimeDropdown',
  components: {
    InputText,
    OverlayPanel,
    RadioButton,
    Calendar
  },
  
  props: {
    modelValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Current Date'
    }
  },
  
  emits: ['update:modelValue', 'focus'],
  
  data() {
    return {
      selectedOption: 'none',
      specificDate: null
    }
  },
  
  computed: {
    displayValue() {
      if (this.modelValue === null) {
        return 'Auto Update';
      }
      if (this.modelValue === 'CurrentDate') {
        return 'Current Date';
      }
      return this.modelValue;
    }
  },
  
  watch: {
    modelValue: {
      handler() {
        this.initializeState()
      },
      immediate: true
    }
  },
  
  methods: {
    toggle(event) {
      if (!this.disabled) {
        this.$refs.overlayPanel.toggle(event)
        this.$emit('focus');
        this.initializeState()
      }
    },
    
    initializeState() {
      if (this.modelValue === null) {
        this.selectedOption = 'none';
      } else if (this.modelValue === 'CurrentDate') {
        this.selectedOption = 'current';
      } else {
        this.selectedOption = 'specific'
        const parts = this.modelValue.split('/');
        // new Date(year, monthIndex, day)
        this.specificDate = new Date(parts[2], parts[1] - 1, parts[0]);
      }
    },
    
    onRadioChange() {
      if (this.selectedOption !== 'specific') {
        this.apply()
      }
    },
    
    onDateSelect() {
      this.apply()
    },
    
    apply() {
      let newValue = null
      
      switch (this.selectedOption) {
        case 'none':
          newValue = null
          break
        case 'current':
          newValue = 'CurrentDate'
          break
        case 'specific':
          newValue = format(this.specificDate, "dd/MM/yyyy")
          break
      }
      
      this.$emit('update:modelValue', newValue)
      this.$refs.overlayPanel.hide()
    }
  }
}
</script>